import { render } from "./JadwalGuru.vue?vue&type=template&id=747fac45"
import script from "./JadwalGuru.vue?vue&type=script&lang=js"
export * from "./JadwalGuru.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__